import { callFromExternal } from '@/utils';
import vnodeSendFailed from '@/assets/img/vnode-failed.svg'
import lbSendFailed from '@/assets/img/lb-failed.png'
import vnodeRead from '@/assets/img/vnode-read.svg'
import lbRead from '@/assets/img/lb-read.png'
import vnodeSend from '@/assets/img/vnode-send.svg'
import lbSend from '@/assets/img/lb-send.svg'
import vnodeSendFocusIcon from '@/assets/img/vnode-send-focus.svg'
import lbSendFocusIcon from '@/assets/img/lb-send-focus.svg'
import vnodeRobotAvatar from '@img/chat/vnode-robot-avatar.svg'
import lbRobotAvatar from '@img/chat/lb-robot-avatar.svg'
import vnodeUserAvatar from '@img/chat/vnode-user-avatar.svg'
import lbUserAvatar from '@img/chat/lb-user-avatar.svg'

import vnodeScrollToBottomIcon from '@/assets/img/vnode-to-bottom.svg'
import lbScrollToBottomIcon from '@/assets/img/lb-to-bottom.svg'

import vnodeUploadIcon from '@/assets/img/vnode-upload.svg'
import lbUploadIcon from '@/assets/img/lb-upload.svg'
const external = callFromExternal()
export const config = {
  // 发送失败图标
  sendFailed: {
    vnode: vnodeSendFailed,
    lb: lbSendFailed
  },
  // 已读图标
  read: {
    vnode: vnodeRead,
    lb: lbRead
  },
  // 聊天内容背景颜色
  bubbleBgColor: {
    vnode: 'rgba(17, 175, 98, 1)',
    lb: 'linear-gradient(90deg, #FFF643 0%, #CE96FF 104.59%)'
  },
  // 发送按钮图标（失焦）
  sendIcon: {
    vnode: vnodeSend,
    lb: lbSend
  },
  // 发送按钮图标（聚焦）
  sendIconFocus: {
    vnode: vnodeSendFocusIcon,
    lb: lbSendFocusIcon
  },
  // 客服机器人头像
  robotAvatar: {
    vnode: vnodeRobotAvatar,
    lb: lbRobotAvatar,
  },
  // 当前用户默认头像
  userAvatar: {
    vnode: vnodeUserAvatar,
    lb: lbUserAvatar,
  },
  // 滚动至底部图标
  scrollToBottomIcon: {
    vnode: vnodeScrollToBottomIcon,
    lb: lbScrollToBottomIcon,
  },
  // 上传按钮图标
  uploadBtnIcon: {
    vnode: vnodeUploadIcon,
    lb: lbUploadIcon,
  },
}
export function getValue(key) {
  if (!config[key]) return ''
  return config[key][external]
}
